module.exports = __webpack_public_path__ + "dingbeauty-landing/img/system_04@1.8f3ef2d3.png";